module.exports = __webpack_public_path__ + "img/群文件管理.c58d6652.png";